import { create } from 'zustand';
import { NotificationState, ToastData } from '../types';

export const useNotificationStore = create<NotificationState>()((set) => ({
  toasts: [],

  addToast: (toast: Omit<ToastData, 'id'>): string => {
    const id = crypto.randomUUID();
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));
    return id;
  },

  removeToast: (id: string) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),

  clearAll: () => set({ toasts: [] }),
}));

/**
 * Helper to add a toast with smart defaults based on type.
 * - success/info/warning: autoDismiss true, duration 3000ms
 * - error: autoDismiss false, duration Infinity
 * Callers can override any default by passing explicit values.
 */
export function addToast(
  type: ToastData['type'],
  message: string,
  overrides?: Partial<Pick<ToastData, 'autoDismiss' | 'duration'>>
): string {
  const isError = type === 'error';
  const defaults = {
    autoDismiss: isError ? false : true,
    duration: isError ? Infinity : 3000,
  };

  return useNotificationStore.getState().addToast({
    type,
    message,
    ...defaults,
    ...overrides,
  });
}
